


























































import { Vue, Component, Prop, Model, Emit } from "vue-property-decorator";
@Component
export default class SuperMultiSelect extends Vue {
  private selectShow: boolean = false;
  private activeIndex: number[] = [];
  private activeColumnIndex: number = -1;
  private saveChooseOption: any[] = [];

  @Model("input", {
    type: Array,
    default: () => [],
  })
  value!: any[];

  @Prop({ default: [], required: true })
  options!: any;

  @Prop({ default: '请选择'})
  placeholder?: string;

  @Prop({ default: false })
  disabled?: boolean;

  mounted() {
    for (let i = 0; i < this.options.length; i++) {
      this.saveChooseOption.push(this.options[i][0].label);
      this.activeIndex.push(0);
    }
    document.addEventListener("click", this.onToggleMain);
  }

  destory() {
    document.removeEventListener("click", this.onToggleMain);
  }

  private get currentValue() {
    return this.value;
  }

  private set currentValue(newValue) {
    this.$emit("input", newValue);
  }

  private get isEmptyValue(): boolean {
    return !(this.currentValue.length > 0);
  }

  private get countValue(): string {
    return this.value.join("-");
  }

  private onOpenSelect() {
    !this.disabled && (this.selectShow = !this.selectShow);
  }

  private onCloseSelect() {
    this.selectShow = false;
  }

  private onSureChoose() {
    this.currentValue = JSON.parse(JSON.stringify(this.saveChooseOption));
    this.onCloseSelect();
  }

  private onToggleMain(e) {
    let selectMain: any = this.$refs.selectMain;
    if (
      !this.$el ||
      this.$el.contains(e.target) ||
      !selectMain ||
      selectMain.contains(e.target)
    ) {
      return false;
    } else {
      this.selectShow = false;
    }
  }

  private onClickOptionItem(item, optionIndex, index) {
    this.$set(this.saveChooseOption, optionIndex, item.label);
    this.$set(this.activeIndex, optionIndex, index);
    this.activeColumnIndex = optionIndex;
    // if (this.activeColumnIndex == this.options.length - 1) {
    //   this.onSureChoose();
    // }
  }
}
